module.exports = __webpack_public_path__ + "img/images/safety.jpg?36c76df7";